export { default } from './recommended-retailers.provider';
